import Criteria from './Criteria';
import Post from './Post';

export default class CompaignAdd {
    post: Post;

    criteria: any;

    constructor(_post: Post, _criteria: any) {
      this.post = _post;
      this.criteria = _criteria;
    }
}
